export default "__VITE_ASSET__BZKtW40K__"